import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Card, CardBody, Row, Col, Table } from "reactstrap";
import { authenticationService } from "services/authentication.service";
import SelectItem2 from '../../Varios/SelectNew';
import AsyncSelect from 'react-select/async';
import configData from "config.json";
import TextEditor from '../../Varios/TextEditor.js';
import { ScrollToTop } from 'functions/LayoutFunctionst';
import { ResponseRequest } from 'components/Types/GeneralTypes';
import { PostProyectosInstitucionales } from "./TypesProyectosInstitucionales"
import { ObtenerAniosHistorial, ObtenerHistorial, GuardarSolicitudProyectosInstitucionales, ProyectosInstitucionalesVistaPrevia, GuardarSolicitudProyectosInstitucionalesFirmada, ObtenerProyectoInstitucional, AnularSolicitud } from './FunctionsProyectosInstitucionales'
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';
import ModalFirmarPDF from 'components/Varios/Modals/ModalFirmarPDF';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';

import Datepicker from '../../Varios/Datepicker';
import { isWeekday } from 'functions/CalendarFunctions';
import { PruebaSolucion3 } from '../../../functions/DatesFunctions';
import { alertService } from 'components/Varios/alert_service';
import Cargando from 'components/Varios/Cargando';
import TablaHistorialProyectosInstitucionales from './TablaHistorialProyectosInstitucionales';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { GetDocumentVistaPrevia } from 'helpers/files';
import Swal from 'sweetalert2';

import ExitoSVG from "assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "assets/icons/Permisos/Error.svg"

type PropsCardProyectosInstitucionales = {
    tiposAmbito: Array<any>,
    tiposFuncion: Array<any>,
    tiposTermino: Array<any>,
    listestructuraorganica: Array<any>,
    periodosacademicos: Array<any>,
    unidad: string,
    idunidad: number
    anio: number
}

type stateModalFormulario = {
    url: string,
    loadingFormulario: boolean,
    tituloModal: string,
    content: HTMLElement | undefined
    solicitudNueva?: PostProyectosInstitucionales
}

type stateModalConfirmacion = {
    showModal: boolean,
    solicitud?: PostProyectosInstitucionales,
    content: HTMLElement | undefined
    tituloModal: string | null,
}

type StateHistorialDetalle = {
    aniosDisponibles: number[],
    tabladetalle: Array<any>,
    loading: boolean,
    error: boolean,
    anioSeleccionado: number
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateInformacionModalRechazar = {
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    observacion: string
}

export default function CardProyectosInstitucionales(props: PropsCardProyectosInstitucionales) {
    const defaultStateModalFormulario: stateModalFormulario = {
        url: "",
        loadingFormulario: false,
        tituloModal: ' ',
        content: undefined,
        solicitudNueva: undefined
    }

    const defaultStateModalConfirmacion: stateModalConfirmacion = {
        solicitud: undefined,
        showModal: false,
        content: undefined,
        tituloModal: ' ',
    }

    const defaultStateHistorialDetalle: StateHistorialDetalle = {
        aniosDisponibles: [],
        tabladetalle: [],
        loading: false,
        error: false,
        anioSeleccionado: -1
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateInformacionModalRechazar: StateInformacionModalRechazar = {
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        observacion: ""
    }

    const [getTiposAmbito, setTiposAmbito] = useState<Array<any>>(props.tiposAmbito)
    const [getTiposFuncion, setTiposFuncion] = useState<Array<any>>(props.tiposFuncion)
    const [getTiposTermino, setTiposTermino] = useState<Array<any>>(props.tiposTermino)
    const [getListEstructuraorganica, setListEstructuraorganica] = useState<Array<any>>(props.listestructuraorganica)
    const [getPeriodosAcademicos, setPeriodosAcademicos] = useState<Array<any>>(props.periodosacademicos)
    const [getUnidad, setUnidad] = useState<string>(props.unidad)
    const [getIdUnidad, setIdUnidad] = useState<number>(props.idunidad)
    const [TiposAmbitoSeleccionado, setTiposAmbitoSeleccionado] = useState<number>(0);
    const [TiposFuncionSeleccionado, setTiposFuncionSeleccionado] = useState<number>(0);
    const [TiposTerminoSeleccionado, setTiposTerminoSeleccionado] = useState<number>(0);
    const [EstructuraorganicaSeleccionado, setEstructuraorganicaSeleccionado] = useState<number>(0);
    const [PeriodosAcademicosSeleccionado, setPeriodosAcademicosSeleccionado] = useState<string>("");
    const [getIdproyectosinstitucionales, setIdproyectosinstitucionales] = useState<number>(0);
    const [getNombre, setNombre] = useState<string>("");
    const [inputValue, setValue] = useState<string>("");
    const [selectedValue, setSelectedValue] = useState(null);
    const [getidpersona, setidpersona] = useState<number>(0);
    const [getNombreProfesor, setNombreProfesor] = useState<string>("");
    const [getCargo, setCargo] = useState<string>("");
    const [getDescripcionFuncion, setDescripcionFuncion] = useState<string>("");
    const [getFechadesde, setFechadesde] = useState<Date | null>(null)
    const [getFechahasta, setFechahasta] = useState<Date | null>(null)
    const [errorFechas, seterrorFechas] = useState<string>("")
    const [getHorasAnuales, setHorasAnuales] = useState<string>("");
    const [getHorasSemanales, setHorasSemanales] = useState<string>("");
    const [getCuerpoCarta, setCuerpoCarta] = useState<string>("");
    const [getActividades, setActividades] = useState<string>("");
    const [stateModalFormulario, setstateModalFormulario] = useState<stateModalFormulario>(defaultStateModalFormulario);
    const [stateModalConfirmacion, setstateModalConfirmacion] = useState<stateModalConfirmacion>(defaultStateModalConfirmacion);
    const [getstateHistorialDetalle, setstateHistorialDetalle] = useState<StateHistorialDetalle>(defaultStateHistorialDetalle);
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia);
    const [stateinformacionModalRechazar, setstateinformacionModalRechazar] = useState(defaultStateInformacionModalRechazar);

    const PAO_1_PAO_2_PAE = 3861;
    const PAE_y_PAO_1 = 3862;
    const PAO_1_y_PAO_2 = 3863;
    const PAO_1 = 3864;
    const PAO_2 = 3865;
    const PAE = 3866;

    const COORDINADOR_OPCION = 3858;
    const RESPONSABLE_OPCION = 3859;
    const COORDINADOR_HORAS = 5;
    const RESPONSABLE_HORAS = 20;

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    const maxLength = 350;
    const maxLengthFuncion = 3000;

    const handleUnidadChange = (event) => {
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            setUnidad(valor);
        }
    };
    const handleEstructuraorganicaChange = (selectedOption: any) => {
        setEstructuraorganicaSeleccionado(selectedOption);
    };

    const handleNombreChange = (event) => {
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            setNombre(valor);
        }
    };

    const handleTipoAmbitoChange = (selectedOption: any) => {
        setTiposAmbitoSeleccionado(selectedOption);
    };

    const handleTipoTerminoChange = (selectedOption: any) => {
        setTiposTerminoSeleccionado(selectedOption);

        var fechaminima = new Date();
        var fechamaxima = new Date();

        for (let i = 0; i < getPeriodosAcademicos.length; i++) {
            if (getPeriodosAcademicos[i].anio === PeriodosAcademicosSeleccionado) {
                for (let j = 0; j < getTiposTermino.length; j++) {
                    if (getTiposTermino[j].idcatalogo === selectedOption && selectedOption === PAO_1_PAO_2_PAE) {
                        fechaminima = new Date(getPeriodosAcademicos[i].min_fecha)
                        fechamaxima = new Date(getPeriodosAcademicos[i].max_fecha)
                    }
                    else if (getTiposTermino[j].idcatalogo === selectedOption && selectedOption === PAE_y_PAO_1) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio1)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin2)
                    }
                    else if (getTiposTermino[j].idcatalogo === selectedOption && selectedOption === PAO_1_y_PAO_2) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio2)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin3)
                    }
                    else if (getTiposTermino[j].idcatalogo === selectedOption && selectedOption === PAE) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio1)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin1)
                    }
                    else if (getTiposTermino[j].idcatalogo === selectedOption && selectedOption === PAO_1) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio2)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin2)
                    }
                    else if (getTiposTermino[j].idcatalogo === selectedOption && selectedOption === PAO_2) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio3)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin3)
                    }
                }
            }
        }

        setFechadesde(fechaminima)
        setFechahasta(fechamaxima)
    };

    const handleInputChange = value => {
        setValue(value);
    };

    const handleChange = value => {
        setSelectedValue(value);
        setidpersona(value.idpersona);
        setCargo(value.cargo);
        setNombreProfesor(value.apellidos + " " + value.nombres)
    }

    const loadOptions = (inputValue) => {
        if (inputValue.length > 3) return fetch(`${configData.SERVER_URL}ProyectosInstitucionales/BuscarPersonaDocente/${inputValue}`).then(res => res.json()).then(result => result.entTabla);
        else return [];
    };

    const handleCargoChange = (event) => {
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            setCargo(valor);
        }
    };

    const handleTipoFuncionChange = (selectedOption: any) => {
        setTiposFuncionSeleccionado(selectedOption);

        var txtfuncion = "";
        for (let i = 0; i < getTiposFuncion.length; i++) {
            if (getTiposFuncion[i].idcatalogo === selectedOption) {
                txtfuncion = getTiposFuncion[i].descripcion
            }
        }
        var txtambito = "";
        for (let i = 0; i < getTiposAmbito.length; i++) {
            if (getTiposAmbito[i].idcatalogo === TiposAmbitoSeleccionado) {
                txtambito = getTiposAmbito[i].descripcion
            }
        }

        if (selectedOption == COORDINADOR_OPCION)
            setHorasSemanales(COORDINADOR_HORAS.toString())
        else if (selectedOption == RESPONSABLE_OPCION)
            setHorasSemanales(RESPONSABLE_HORAS.toString())

        var cuerpocarta = '<p style="text-align: justify;">Reciba un cordial saludo.\
                    Considerando la necesidad institucional de realizar proyectos en las líneas de investigación del área de conocimiento de la <b>' + getUnidad + '</b>, pongo a su consideración la designación del profesor <b>' +
            getNombreProfesor + '</b>, <b>' + getCargo + '</b>, como <b>' + txtfuncion + '</b> del Proyecto Institucional "<b>' + getNombre + '</b>", del ámbito <b>' + txtambito + '</b>, quien desempeñará las siguientes funciones: \
                <br></p>';
        setCuerpoCarta(cuerpocarta)
    };

    const handleActividadesChange = (value) => {
        const valor = value;
        if (valor.length <= maxLengthFuncion) {
            setActividades(valor);
        }
    };

    const handleDescripcionFuncionChange = (value) => {
        const valor = value;
        if (valor.length <= maxLengthFuncion) {
            setDescripcionFuncion(valor);
        }
    };

    const handlePeriodoAcademicoChange = (selectedOption: any) => {
        setPeriodosAcademicosSeleccionado(selectedOption);
        setTiposTerminoSeleccionado(0);
        setFechadesde(null)
        setFechahasta(null)
    };

    const handleHorasAnualesChange = (event) => {
        const valor = event.target.value;
        setHorasAnuales(valor);
    };

    const handleHorasSemanalesChange = (event) => {
        const valor = event.target.value;
        setHorasSemanales(valor);
    };

    const handleCuerpocartaChange = (value) => {
        const valor = value;
        if (valor.length <= maxLengthFuncion) {
            setCuerpoCarta(valor);
        }
    };

    const limpiar = useCallback(
        () => {
            setIdproyectosinstitucionales(0)
            setNombre("")
            setTiposAmbitoSeleccionado(0)
            setidpersona(0)
            setSelectedValue(null)
            setEstructuraorganicaSeleccionado(0)
            setCargo("")
            setTiposFuncionSeleccionado(0)
            setDescripcionFuncion("")
            setActividades("")

            setPeriodosAcademicosSeleccionado("")
            setTiposTerminoSeleccionado(0)
            setFechadesde(null)
            setFechahasta(null)
            setHorasAnuales("")
            setHorasSemanales("")

            setCuerpoCarta("")

            seterrorFechas("")
        },
        [getIdproyectosinstitucionales, getidpersona, getNombre, TiposAmbitoSeleccionado, getCargo, TiposFuncionSeleccionado, PeriodosAcademicosSeleccionado, TiposTerminoSeleccionado, getFechadesde, getFechahasta, getHorasAnuales, getHorasSemanales, errorFechas],
    )

    const validarCamposProyectoInstitucional = () => {
        return getidpersona != undefined && getNombre != undefined && TiposAmbitoSeleccionado != undefined && getIdUnidad != undefined && getCargo != "" && TiposFuncionSeleccionado != undefined && PeriodosAcademicosSeleccionado != undefined && TiposTerminoSeleccionado != undefined && getFechadesde != undefined && getFechahasta != undefined && getHorasAnuales != undefined && getHorasAnuales != "" && getHorasSemanales != undefined && getHorasSemanales != "" && errorFechas == "" && getCuerpoCarta != undefined && getCuerpoCarta != ""
    }

    const DatePickerFechaDesde = useCallback(() => {
        var fechaminima = new Date();
        var fechamaxima = new Date();

        for (let i = 0; i < getPeriodosAcademicos.length; i++) {
            if (getPeriodosAcademicos[i].anio === PeriodosAcademicosSeleccionado) {
                for (let j = 0; j < getTiposTermino.length; j++) {
                    if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_1_PAO_2_PAE) {
                        fechaminima = new Date(getPeriodosAcademicos[i].min_fecha)
                        fechamaxima = new Date(getPeriodosAcademicos[i].max_fecha)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAE_y_PAO_1) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio1)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin2)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_1_y_PAO_2) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio2)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin3)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAE) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio1)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin1)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_1) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio2)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin2)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_2) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio3)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin3)
                    }
                }
            }
        }

        return (
            <Datepicker
                value={getFechadesde}
                name="fechadesde"
                id="fechadesde"
                onChange={(e) => setFechadesde(e)}
                min={fechaminima}
                max={fechamaxima}
                filter={(datefilter: Date) => isWeekday(datefilter)}
                showDisabledMonthNavigation={true}
                required
            />
        )
    }, [getFechadesde, getPeriodosAcademicos, PeriodosAcademicosSeleccionado, getTiposTermino, TiposTerminoSeleccionado, errorFechas])

    const DatePickerFechaHasta = useCallback(() => {
        var fechaminima = new Date();
        var fechamaxima = new Date();

        for (let i = 0; i < getPeriodosAcademicos.length; i++) {
            if (getPeriodosAcademicos[i].anio === PeriodosAcademicosSeleccionado) {
                for (let j = 0; j < getTiposTermino.length; j++) {
                    if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_1_PAO_2_PAE) {
                        fechaminima = new Date(getPeriodosAcademicos[i].min_fecha)
                        fechamaxima = new Date(getPeriodosAcademicos[i].max_fecha)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAE_y_PAO_1) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio1)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin2)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_1_y_PAO_2) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio2)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin3)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAE) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio1)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin1)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_1) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio2)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin2)
                    }
                    else if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_2) {
                        fechaminima = new Date(getPeriodosAcademicos[i].fechainicio3)
                        fechamaxima = new Date(getPeriodosAcademicos[i].fechafin3)
                    }
                }
            }
        }

        return (
            <Datepicker
                value={getFechahasta}
                name="fechahasta"
                id="fechahasta"
                onChange={(e) => setFechahasta(e)}
                min={fechaminima}
                max={fechamaxima}
                filter={(datefilter: Date) => isWeekday(datefilter)}
                showDisabledMonthNavigation={true}
                required
            />
        )
    }, [getFechahasta, getPeriodosAcademicos, PeriodosAcademicosSeleccionado, getTiposTermino, TiposTerminoSeleccionado, errorFechas])

    useEffect(() => {
        if (getFechadesde != undefined && getFechahasta != undefined) {
            if (getFechahasta.getTime() < getFechadesde.getTime()) {
                seterrorFechas("La fecha hasta no puede ser menor a la fecha desde")
            }
            else {
                seterrorFechas("")
            }
        }
    }, [getFechadesde, getFechahasta, errorFechas])

    useEffect(() => {
        if (getFechadesde != undefined && getFechahasta != undefined && getHorasSemanales != undefined && getHorasSemanales != "") {
            if (getFechahasta.getTime() >= getFechadesde.getTime()) {
                var fechadesde = getFechadesde.getTime();
                var fechahasta = getFechahasta.getTime();
                var diff = fechahasta - fechadesde;
                var dias_milisegundos = 1000 * 60 * 60 * 24;

                for (let i = 0; i < getPeriodosAcademicos.length; i++) {
                    if (getPeriodosAcademicos[i].anio === PeriodosAcademicosSeleccionado) {
                        for (let j = 0; j < getTiposTermino.length; j++) {
                            if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_1_y_PAO_2
                                && fechadesde === new Date(getPeriodosAcademicos[i].fechainicio2).getTime() && fechahasta === new Date(getPeriodosAcademicos[i].fechafin3).getTime()) {
                                diff = 24192000000;
                            }
                        }
                    }
                }

                setHorasAnuales(((Math.ceil(diff / (dias_milisegundos) / 7) > 48 ? 48 : Math.ceil(diff / (dias_milisegundos) / 7)) * Number(getHorasSemanales)).toString())
            }
            else {
                setHorasAnuales("")
            }
        }
    }, [getHorasSemanales, getFechadesde, getFechahasta])

    useEffect(() => {
        if (getFechadesde != undefined && getFechahasta != undefined && getHorasSemanales != undefined && getHorasSemanales != "") {
            if (TiposFuncionSeleccionado == COORDINADOR_OPCION && Number(getHorasSemanales) <= COORDINADOR_HORAS) {
                var fechadesde = getFechadesde.getTime();
                var fechahasta = getFechahasta.getTime();
                var diff = fechahasta - fechadesde;

                for (let i = 0; i < getPeriodosAcademicos.length; i++) {
                    if (getPeriodosAcademicos[i].anio === PeriodosAcademicosSeleccionado) {
                        for (let j = 0; j < getTiposTermino.length; j++) {
                            if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_1_y_PAO_2
                                && fechadesde === new Date(getPeriodosAcademicos[i].fechainicio2).getTime() && fechahasta === new Date(getPeriodosAcademicos[i].fechafin3).getTime()) {
                                diff = 24192000000;
                            }
                        }
                    }
                }

                var dias_milisegundos = 1000 * 60 * 60 * 24;

                setHorasAnuales(((Math.ceil(diff / (dias_milisegundos) / 7) > 48 ? 48 : Math.ceil(diff / (dias_milisegundos) / 7)) * Number(getHorasSemanales)).toString())
            }
            else if (TiposFuncionSeleccionado == RESPONSABLE_OPCION && Number(getHorasSemanales) <= RESPONSABLE_HORAS) {
                var fechadesde = getFechadesde.getTime();
                var fechahasta = getFechahasta.getTime();
                var diff = fechahasta - fechadesde;
                var dias_milisegundos = 1000 * 60 * 60 * 24;

                for (let i = 0; i < getPeriodosAcademicos.length; i++) {
                    if (getPeriodosAcademicos[i].anio === PeriodosAcademicosSeleccionado) {
                        for (let j = 0; j < getTiposTermino.length; j++) {
                            if (getTiposTermino[j].idcatalogo === TiposTerminoSeleccionado && TiposTerminoSeleccionado === PAO_1_y_PAO_2
                                && fechadesde === new Date(getPeriodosAcademicos[i].fechainicio2).getTime() && fechahasta === new Date(getPeriodosAcademicos[i].fechafin3).getTime()) {
                                diff = 40;
                            }
                        }
                    }
                }

                setHorasAnuales(((Math.ceil(diff / (dias_milisegundos) / 7) > 48 ? 48 : Math.ceil(diff / (dias_milisegundos) / 7)) * Number(getHorasSemanales)).toString())
            }
            else {
                setHorasSemanales("")
                setHorasAnuales("")
            }
        }
    }, [getHorasSemanales, TiposFuncionSeleccionado, getHorasAnuales])

    const handleClickGuardar = useCallback(
        async function () {
            var titulo = "";
            var respuesta: ResponseRequest = { status: -1 };

            const formData = new FormData()
            formData.append('idproyectosinstitucionales', getIdproyectosinstitucionales.toString())
            formData.append('nombreproyecto', getNombre)
            formData.append('ambito', TiposAmbitoSeleccionado.toString())
            formData.append('idestructuraorganica', getIdUnidad.toString())
            formData.append('idpersona', getidpersona.toString())
            formData.append('cargo', getCargo)
            formData.append('funcion', TiposFuncionSeleccionado.toString())
            formData.append('descripcionfuncion', getDescripcionFuncion)
            formData.append('anio', PeriodosAcademicosSeleccionado)
            formData.append('termino', TiposTerminoSeleccionado.toString())
            formData.append('fechadesde', PruebaSolucion3(getFechadesde))
            formData.append('fechahasta', PruebaSolucion3(getFechahasta))
            formData.append('horasanuales', getHorasAnuales.toString())
            formData.append('horassemanales', getHorasSemanales.toString())
            formData.append('cuerpocarta', getCuerpoCarta)
            formData.append('actividades', getActividades)

            respuesta = await GuardarSolicitudProyectosInstitucionales(formData);

            if (respuesta.status === 200) {
                limpiar()
                ScrollToTop();

                await ObtenerInformacionAniosHistorial();
                await showAlert("Se ha guardado la solicitud", ExitoSVG, true);

                return respuesta.status;
            }
        }, [getIdproyectosinstitucionales, getNombre, TiposAmbitoSeleccionado, getIdUnidad, getidpersona, getCargo, TiposFuncionSeleccionado, getDescripcionFuncion, PeriodosAcademicosSeleccionado, TiposTerminoSeleccionado, getFechadesde, getFechahasta, getHorasAnuales, getHorasSemanales, getCuerpoCarta, getActividades]
    );

    const handleClickFirmaryEnviar = useCallback(
        async () => {
            var titulo = "";
            var respuestaSolicitud: ResponseRequest = { status: -1 };
            let solicitudNueva: PostProyectosInstitucionales = {
                idproyectosinstitucionales: 0,
                NombreProyecto: "",
                Ambito: 0,
                idpersona: 0,
                idestructuraorganica: 0,
                nombreproyectocatalogo: "",
                Cargo: "",
                Funcion: 0,
                Descripcionfuncion: "",
                Anio: "",
                Termino: 0,
                Fechadesde: "",
                Fechahasta: "",
                HorasAnuales: "",
                HorasSemanales: "",
                Cuerpocarta: "",
                Cuerpocartaautoridad: "",
                Actividades: ""
            };

            solicitudNueva = {
                idproyectosinstitucionales: getIdproyectosinstitucionales,
                NombreProyecto: getNombre,
                Ambito: TiposAmbitoSeleccionado,
                idpersona: getidpersona,
                idestructuraorganica: getIdUnidad,
                nombreproyectocatalogo: "",
                Cargo: getCargo,
                Funcion: TiposFuncionSeleccionado,
                Descripcionfuncion: getDescripcionFuncion,
                Anio: PeriodosAcademicosSeleccionado,
                Termino: TiposTerminoSeleccionado,
                Fechadesde: getFechadesde,
                Fechahasta: getFechahasta,
                HorasAnuales: getHorasAnuales,
                HorasSemanales: getHorasSemanales,
                Cuerpocarta: getCuerpoCarta,
                Cuerpocartaautoridad: "",
                Actividades: getActividades
            }
            var content: any = "";
            respuestaSolicitud = await ProyectosInstitucionalesVistaPrevia(solicitudNueva);
            setstateModalFormulario({ url: respuestaSolicitud.dataResponse, loadingFormulario: false, tituloModal: titulo, content, solicitudNueva })

            ScrollToTop();
        }, [getIdproyectosinstitucionales, getNombre, TiposAmbitoSeleccionado, getIdUnidad, getidpersona, getCargo, TiposFuncionSeleccionado, getDescripcionFuncion, PeriodosAcademicosSeleccionado, TiposTerminoSeleccionado, getFechadesde, getFechahasta, getHorasAnuales, getHorasSemanales, getCuerpoCarta, getActividades]
    )

    const FirmarDocumentoSolicitud = async (objeto: any) => {
        var contrasenia = objeto.contrasenia;
        var filesData = objeto.filesEnviar;

        var respuestaSolicitud: ResponseRequest = { status: -1 };

        if (contrasenia && filesData.length > 0) {
            var formData = new FormData();
            formData.append("contrasenia", contrasenia);
            filesData.map((fData) => {
                formData.append("files", fData.file, fData.file.name);
            });

            formData.append('idproyectosinstitucionales', getIdproyectosinstitucionales.toString())
            formData.append('nombreproyecto', getNombre)
            formData.append('ambito', TiposAmbitoSeleccionado.toString())
            formData.append('idpersona', getidpersona.toString())
            formData.append('idestructuraorganica', getIdUnidad.toString())
            formData.append('cargo', getCargo)
            formData.append('funcion', TiposFuncionSeleccionado.toString())
            formData.append('descripcionfuncion', getDescripcionFuncion)
            formData.append('anio', PeriodosAcademicosSeleccionado)
            formData.append('termino', TiposTerminoSeleccionado.toString())
            formData.append('fechadesde', PruebaSolucion3(getFechadesde))
            formData.append('fechahasta', PruebaSolucion3(getFechahasta))
            formData.append('horasanuales', getHorasAnuales)
            formData.append('horassemanales', getHorasSemanales)
            formData.append('cuerpocarta', getCuerpoCarta)
            formData.append('actividades', getActividades)

            respuestaSolicitud = await GuardarSolicitudProyectosInstitucionalesFirmada(formData);

            if (respuestaSolicitud.status === 200) {
                limpiar()
                ScrollToTop();

                await ObtenerInformacionAniosHistorial();
                await showAlert("Se ha firmado la solicitud", ExitoSVG, true);

                setstateModalFormulario(defaultStateModalFormulario)
            }
            else {
                await showAlert(respuestaSolicitud.errorMessage, ErrorSVG, false);
            }
        }
    }

    async function ObtenerInformacionAniosHistorial() {
        setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: true })
        const respuesta = await ObtenerAniosHistorial();
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial");
            setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: false, error: true })
        }
        else {
            const anioSeleccionado = respuesta.dataResponse[0]
            setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: false, aniosDisponibles: respuesta.dataResponse, anioSeleccionado })
        }
    }

    async function ConsultarHistorial(stateHistorial: StateHistorialDetalle) {
        setstateHistorialDetalle({ ...stateHistorial, loading: true })
        const anio = stateHistorial.anioSeleccionado
        const respuesta = await ObtenerHistorial(anio)
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial")
            setstateHistorialDetalle({ ...stateHistorial, error: true, loading: false })
        }
        else {
            setstateHistorialDetalle({ ...stateHistorial, tabladetalle: respuesta.dataResponse, loading: false })
        }
    }

    useEffect(() => {
        ObtenerInformacionAniosHistorial();
    }, [])

    useEffect(() => {
        if (getstateHistorialDetalle.aniosDisponibles.length > 0) {
            ConsultarHistorial(getstateHistorialDetalle);
        }
    }, [getstateHistorialDetalle.aniosDisponibles])

    const onClickVerDoc = useCallback(async (referencia: string) => {
        setstateModalVP({ ...stateModalVP, loading: true })
        const datosUsuario: UserData = authenticationService.currentUserValue;
        const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
        setstateModalVP({ ...stateModalVP, loading: false, url })
    }, [stateModalVP])

    const GetHistorialByAnio = useCallback(async (anio: number) => {
        setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: true })
        const respuesta = await ObtenerHistorial(anio)

        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de aprobaciones")
            setstateHistorialDetalle({ ...getstateHistorialDetalle, error: true, loading: false })
        }
        else {
            setstateHistorialDetalle({ ...getstateHistorialDetalle, tabladetalle: respuesta.dataResponse, loading: false, anioSeleccionado: anio })
        }
    }, [getstateHistorialDetalle])

    async function onClickVerDetalleProyecto(informacionAcciones) {
        var respuesta = await ObtenerProyectoInstitucional(informacionAcciones.idproyectosinstitucionales)
        if (respuesta.status === 200) {
            var obj = respuesta.dataResponse.proyecto[0];
            var objcontrato = respuesta.dataResponse.contrato;

            setIdproyectosinstitucionales(obj.idproyectosinstitucionales)
            setNombre(obj.nombreproyecto)
            setTiposAmbitoSeleccionado(obj.idambito)
            setidpersona(obj.idpersona)

            setSelectedValue(objcontrato)

            setNombreProfesor(objcontrato.apellidos + " " + objcontrato.nombres)
            setEstructuraorganicaSeleccionado(obj.idestructuraorganica)
            setTiposFuncionSeleccionado(obj.idfuncion)

            setCargo(obj.cargo)
            setDescripcionFuncion(obj.descripcionfuncion)

            setPeriodosAcademicosSeleccionado(obj.anio)
            setTiposTerminoSeleccionado(obj.idtermino)

            var fechaEscogidaDesde = new Date(obj.fechadesde);
            var fechaEscogidaHasta = new Date(obj.fechahasta);

            setFechadesde(fechaEscogidaDesde)
            setFechahasta(fechaEscogidaHasta)
            setHorasAnuales(obj.horasanuales.toString())
            setHorasSemanales(obj.horasmensuales.toString())

            setCuerpoCarta(obj.cuerpocarta)
            setActividades(obj.actividades)

            ScrollToTop();
        }
        else {
            alertService.error("Ha ocurrido un inconveniente al obtener la información")
        }
    }

    async function OnCloseModalRechazo() {
        setstateinformacionModalRechazar(defaultStateInformacionModalRechazar);
        await ObtenerInformacionAniosHistorial();
    }

    async function RechazarSolicitud(idSolicitud, observacion) {
        const respuesta = await AnularSolicitud(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
        }
        else {
            await showAlert("Se ha anulado la solicitud", ExitoSVG, true);
        }
        return respuesta.status;
    }

    function onClickRechazarProyecto(informacionAcciones) {
        const modalContent = AuxiliarGenerarHTMLBodyModalRechazarProyecto(informacionAcciones);

        setstateinformacionModalRechazar({
            cargando: false,
            idSolicitud: informacionAcciones.idproyectosinstitucionales,
            modalContent,
            observacion: ""
        })
    }

    function AuxiliarGenerarHTMLBodyModalRechazarProyecto(informacionAcciones): any {
        return (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Nombre proyecto </th>
                            <th> Ámbito </th>
                            <th> Identificación</th>
                            <th> Nombres</th>
                            <th> Cargo</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombreproyecto}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.ambito}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.identificacion}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.cargo}
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </Table>
            </>
        )
    }

    const TablaHistorialSolicitudesProyectosInstitucionales = useMemo(() => {
        if (getstateHistorialDetalle.loading) {
            return <Cargando />
        }
        else if (getstateHistorialDetalle.error) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!getstateHistorialDetalle.error && (getstateHistorialDetalle.aniosDisponibles.length === 0 && getstateHistorialDetalle.tabladetalle.length === 0)) {
            return <div className="row-no-margin">No hay historial de solicitudes por mostrar</div>
        }
        else if (!getstateHistorialDetalle.loading && getstateHistorialDetalle.tabladetalle.length > 0) {
            return (
                <TablaHistorialProyectosInstitucionales
                    anioSeleccionado={getstateHistorialDetalle.anioSeleccionado}
                    dataFilas={getstateHistorialDetalle.tabladetalle}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onChangeAnio={(anio: number) => GetHistorialByAnio(anio)}
                    onClickVerDetalle={async (solicitud: any) => await onClickVerDetalleProyecto(solicitud)}
                    onClickRechazar={(solicitud: any) => onClickRechazarProyecto(solicitud)}
                />
            )
        }
    }, [getstateHistorialDetalle]);

    return (
        <>
            <Row>
                <Col md={12} xl={12}>

                    <Card id="CardProyectosInstitucionales">
                        <CardBody
                            className="cardBodyContenedorProyectosInstitucionales"
                            style={{ padding: "0px !important" }}
                        >
                            <div id="container-CBSolicitudes">
                                <Row className="row-no-margin">
                                    <Col md={4} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="nombre"
                                                className="label-permiso"
                                            >
                                                Nombre del proyecto*
                                            </Label>
                                            <Input
                                                type="text"
                                                value={getNombre}
                                                onChange={handleNombreChange}
                                                maxLength={350}
                                                id="nombre"
                                                style={{ minHeight: "30px" }}
                                                required
                                            ></Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="tipoAmbito"
                                                className="label-permiso"
                                            >
                                                Ámbito del proyecto*
                                            </Label>
                                            <SelectItem2
                                                options={getTiposAmbito.map((ambito) => ({
                                                    value: ambito.idcatalogo,
                                                    label: ambito.descripcion,
                                                }))}
                                                placeholder=""
                                                name="tipoAmbito"
                                                id="tipoAmbito"
                                                icon="fa-caret-down"
                                                value={TiposAmbitoSeleccionado}
                                                onChange={handleTipoAmbitoChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="Estructuraorganica"
                                                className="label-permiso"
                                            >
                                                Unidad responsable del proyecto*
                                            </Label>
                                            <SelectItem2
                                                options={getListEstructuraorganica.map((estructuraorganica) => ({
                                                    value: estructuraorganica.idestructuraorganica,
                                                    label: estructuraorganica.nombre,
                                                }))}
                                                placeholder=""
                                                name="Estructuraorganica"
                                                id="Estructuraorganica"
                                                icon="fa-caret-down"
                                                value={getIdUnidad}
                                                onChange={handleEstructuraorganicaChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="row-no-margin">
                                    <Col md={8} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="tipoAmbito"
                                                className="label-permiso"
                                            >
                                                Nombre*
                                            </Label>
                                            <AsyncSelect
                                                cacheOptions
                                                defaultOptions
                                                placeholder="Buscar persona - Apellidos | Identificación"
                                                loadingMessage={() => "Buscando . . ."}
                                                noOptionsMessage={() => "No existe información para mostrar"}
                                                value={selectedValue}
                                                getOptionLabel={e => e.apellidos + " " + e.nombres}
                                                getOptionValue={e => e.idpersona}
                                                loadOptions={loadOptions}
                                                onInputChange={handleInputChange}
                                                onChange={handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="cargo"
                                                className="label-permiso"
                                            >
                                                Cargo*
                                            </Label>
                                            <Input
                                                type="text"
                                                value={getCargo}
                                                onChange={handleCargoChange}
                                                maxLength={350}
                                                id="cargo"
                                                style={{ minHeight: "30px" }}
                                                disabled={true}
                                            ></Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="row-no-margin">
                                    <Col md={12} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="tipoFuncion"
                                                className="label-permiso"
                                            >
                                                Función a desempeñar*
                                            </Label>
                                            <SelectItem2
                                                options={getTiposFuncion.map((funcion) => ({
                                                    value: funcion.idcatalogo,
                                                    label: funcion.descripcion,
                                                }))}
                                                placeholder=""
                                                name="tipoFuncion"
                                                id="tipoFuncion"
                                                icon="fa-caret-down"
                                                value={TiposFuncionSeleccionado}
                                                onChange={handleTipoFuncionChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="row-no-margin">
                                    <Col md={2} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="idanio"
                                                className="label-permiso"
                                            >
                                                Año académico*
                                            </Label>
                                            <SelectItem2
                                                options={getPeriodosAcademicos.map((periodo) => ({
                                                    value: periodo.anio,
                                                    label: periodo.min_anio + " - " + periodo.max_anio,
                                                }))}
                                                placeholder=""
                                                name="tipoPeriodo"
                                                id="tipoPeriodo"
                                                icon="fa-caret-down"
                                                value={PeriodosAcademicosSeleccionado}
                                                onChange={handlePeriodoAcademicoChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="tipoTermino"
                                                className="label-permiso"
                                            >
                                                Termino académico*
                                            </Label>
                                            <SelectItem2
                                                options={getTiposTermino.map((termino) => ({
                                                    value: termino.idcatalogo,
                                                    label: termino.descripcion,
                                                }))}
                                                placeholder=""
                                                name="tipoTermino"
                                                id="tipoTermino"
                                                icon="fa-caret-down"
                                                value={TiposTerminoSeleccionado}
                                                onChange={handleTipoTerminoChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="fechadesde"
                                                className="label-permiso"
                                            >
                                                Fecha desde*
                                            </Label>
                                            {DatePickerFechaDesde()}
                                        </FormGroup>
                                    </Col>
                                    <Col md={2} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="fechahasta"
                                                className="label-permiso"
                                            >
                                                Fecha hasta*
                                            </Label>
                                            {DatePickerFechaHasta()}
                                        </FormGroup>
                                    </Col>
                                    <Col md={2} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="idhorassemanales"
                                                className="label-permiso"
                                            >
                                                Horas semanales*
                                            </Label>
                                            <Input
                                                type="number"
                                                step="1"
                                                name="idhorassemanales"
                                                id="idhorassemanales"
                                                value={getHorasSemanales}
                                                onChange={handleHorasSemanalesChange}
                                                required
                                                style={{ minHeight: "30px" }}
                                                disabled={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="idhorasanuales"
                                                className="label-permiso"
                                            >
                                                Horas anuales*
                                            </Label>
                                            <Input
                                                type="number"
                                                step="1"
                                                name="idhorasanuales"
                                                id="idhorasanuales"
                                                value={getHorasAnuales}
                                                onChange={handleHorasAnualesChange}
                                                required
                                                style={{ minHeight: "30px" }}
                                                disabled={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="rowErroresHoras">
                                    <Col xs={6}>

                                    </Col>
                                    <Col xs={6}>
                                        <small className='small-error'>{errorFechas}</small>
                                    </Col>
                                </Row>
                                <Row className="row-no-margin">
                                    <Col md={12} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="actividades"
                                                className="label-permiso"
                                            >
                                                Actividades*
                                            </Label>
                                            <TextEditor
                                                onChange={handleActividadesChange}
                                                name="actividades"
                                                value={getActividades}
                                                placeholder="Describa las actividades"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="row-no-margin">
                                    <Col md={12} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="descripcionfuncion"
                                                className="label-permiso"
                                            >
                                                Productos/resultados a entregar*
                                            </Label>
                                            <TextEditor
                                                onChange={handleDescripcionFuncionChange}
                                                name="descripcionfuncion"
                                                value={getDescripcionFuncion}
                                                placeholder="Describa los productos / resultados usando viñetas"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="row-no-margin">
                                    <Col md={12} className="pr-0">
                                        <FormGroup>
                                            <Label
                                                for="cuerpocarta"
                                                className="label-permiso"
                                            >
                                                Cuerpo del documento*
                                            </Label>
                                            <TextEditor
                                                onChange={handleCuerpocartaChange}
                                                name="cuerpocarta"
                                                value={getCuerpoCarta}
                                                placeholder="Cuerpo del documento"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="row-no-margin text-center">
                                    <Button
                                        onClick={() => handleClickGuardar()}
                                        disabled={
                                            !validarCamposProyectoInstitucional()
                                        }
                                    >
                                        GUARDAR{" "}
                                    </Button>
                                    <Button
                                        onClick={() => handleClickFirmaryEnviar()}
                                        disabled={
                                            !validarCamposProyectoInstitucional()
                                        }
                                    >
                                        FIRMAR Y ENVIAR{" "}
                                    </Button>
                                </Row>
                                {/*<Row className="row-no-margin text-center">*/}
                                {/*    <Button*/}
                                {/*        onClick={() => limpiar()}*/}

                                {/*    >*/}
                                {/*        limpiar{" "}*/}
                                {/*    </Button>*/}
                                {/*</Row>*/}
                            </div>
                        </CardBody>
                    </Card>

                </Col>
            </Row>
            <Row>
                <Col md={12} xl={12}>
                    <p className="margen-superior no-margen-inferior titulo-solicitudes"><strong>Solicitudes ingresadas</strong></p>
                    {
                        TablaHistorialSolicitudesProyectosInstitucionales
                    }
                </Col>
            </Row>

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento'
                urlArchivo={stateModalVP.url}
                botonCerrar={false}
            />

            <ModalConfirmacion
                show={stateinformacionModalRechazar.idSolicitud > 0 || stateinformacionModalRechazar.cargando}
                size="lg"
                mensajeConfirmacion={'¿Desea anular la solicitud?'}
                classNamemensajeConfirmacion='mensajeConfirmacionAnulacionSolicitud'
                tituloModal='Anulación de Solicitud'
                nombreBotonAccion='Aceptar'
                nombreBotonCerrarModal='Cancelar'
                onClose={() => setstateinformacionModalRechazar(defaultStateInformacionModalRechazar)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                asyncOnClick={() => RechazarSolicitud(stateinformacionModalRechazar.idSolicitud, { Observacion: "" })}
                contentModal={stateinformacionModalRechazar.modalContent}
                classNameAllModal={""}
            />

            <ModalFirmarPDF
                show={(stateModalFormulario.url !== undefined && stateModalFormulario.url !== "") || stateModalFormulario.loadingFormulario}
                tituloModal='Solicitud para designación de responsable de Proyecto Institucional'
                admiteFirmaFisica={false}
                size="xl"
                urlArchivo={stateModalFormulario.url}
                onClose={() => setstateModalFormulario(defaultStateModalFormulario)}
                cargandoDatos={stateModalFormulario.loadingFormulario}
                onClickFirma={(objeto) => FirmarDocumentoSolicitud(objeto)}

            />
        </>
    );
}